/**
 * Puente entre el orden del repo y el del `DataTable`.
 *
 * 🔴 Los dos tipos existen y NO se llaman igual: `SortableHeader` del repo usa
 * `{ field, direction }` y el `DataTable` del sistema `{ key, dir }`. Sin esto,
 * cada pantalla con orden por servidor escribe la misma traducción de dos
 * líneas — y son **33 de las 117 tablas** las que paginan por servidor, así que
 * es el tipo de repetición que el barrido tiene que eliminar, no propagar.
 *
 * ⚠️ Y el riesgo no es la repetición sino equivocarse en una: si alguien invierte
 * `asc`/`desc` al traducir, la tabla pide al backend el orden contrario al que
 * muestra la flecha. No hay error, hay un orden que miente — el mismo modo de
 * fallar que documenta `sortable`.
 *
 * Uso:
 *
 *     <DataTable
 *       columns={[{ key: 'supplier', header: 'Proveedor', sortable: true }]}
 *       {...ordenControlado(sort, handleSortChange)}
 *     />
 *
 * 🔴 La `key` de cada columna ordenable tiene que ser **el nombre del campo que
 * el backend espera** (`?ordering=`), porque es lo que viaja. Si no coincide, el
 * backend ignora el orden y la tabla se queda como estaba.
 */
import type { SortState as SortDataTable } from './DataTable'
import type { SortState as SortRepo } from '@/components/SortableHeader'

export function ordenControlado(
  sort: SortRepo | null | undefined,
  onSortChange: (next: SortRepo) => void,
): { sort?: SortDataTable; onSortChange: (s: SortDataTable) => void } {
  return {
    sort: sort ? { key: sort.field, dir: sort.direction } : undefined,
    onSortChange: (s) => onSortChange({ field: s.key, direction: s.dir }),
  }
}
